import React, { ReactNode } from 'react';
import _ from 'lodash';
// import { useLocation } from 'react-router-dom'

// import {
//   Row,
//   Col,
//   Card,
// } from 'react-bootstrap';
// import styled from 'styled-components';
// import { up, down } from 'styled-breakpoints';

import { Spin } from "antd";

// Auth
// import { useAuthContext } from '../../../../v5/auth/use-auth-context.js';
// import { useRouter } from '../../../../v5/auth/auth-guard.js';

// Redux
import { useDispatch } from 'react-redux';
import { RootState, AppDispatch, useTypedSelector } from '../../../../v5/utils/store.tsx';
import slice, { useFormikContext, fields, findStatus, driverMarkerIcon, arrowMarkerIcon, defaultMarkerIcon, isEdit, checkStatus, showRoute } from '../slice.tsx';
import jobSummarySlice from './jobSummary/slice.tsx';

// enums
import { getDefLatLngZoomV4, info, validateLatLng, convertLatLngToCoord, convertCoordToLatLng } from '../../../../v5/utils/utils.tsx';
// import {  } from '../../../../v5/utils/enums.tsx';

// import {  } from '../../../components/googleMap/Spiderfy.jsx';
import { LocationEnum, getStepsFromStepGroups } from '../../manage/jobs/jobTypes/slice.tsx';

// components
// import MainContainer from '../../../../v5/components/container/MainContainer.jsx';
import GoogleMap, { addMarker, clearAllMarkers, addPolyline, clearAllPolyline } from '../../../../v5/components/googleMap/GoogleMap.jsx';

// import { ReactComponent as XIcon } from "../../../../v5/assets/icons/smallX.svg";

// ----------------------------------------------------------------------


const Map = () => {
  const defaultLatLngZoom: any = getDefLatLngZoomV4();
  // const location = useLocation();
  // const router = useRouter();
  
  const { values, errors, setValues, setFieldValue, validateForm, handleSubmit }: any = useFormikContext();

  const { isLoading, latestLocationDrivers, isLoadingLatestLocationDrivers, defaultLocations, isLoadingDistance, distance } = useTypedSelector((state: RootState) => state.jobFormSlice);
  const dispatch = useDispatch<AppDispatch>();

  const [map, setMap] = React.useState<any>(null);

  // const [showTrafficLayer, setShowTrafficLayer] = React.useState<any>(false);
  // const [customButtons, setCustomButtons] = React.useState<Array<any>>([]);
  const [customElements, setCustomElements] = React.useState<Array<any>>([
    {
      element: 'span',
      text: 'Total: 0 km',
      className: 'badge bg-custom-light btn-lg',
      style: {
        position: 'absolute',
        bottom: '25px',
        left: '10px',
      },
      visible: true,
      disabled: false,
      callback: null,
    },
    {
      element: 'button',
      text: 'See larger view',
      className: 'btn btn-custom-outlined btn-sm',
      style: {
        position: 'absolute',
        bottom: '25px',
        right: '10px',
      },
      visible: true,
      disabled: !(values.steps && values.steps.length > 0),
      callback: (e: any) => onClickView(),
    }
  ]);


  const getCoordinates = (stepGroups: any = []) => {
    let combinedCoordinates: Array<any> = [];
    
    let arr = getStepsFromStepGroups(stepGroups);
    if(arr && arr.length > 0){
      arr.forEach((site: any) => {
        if(site?.locationType == LocationEnum.CustomerSite){
          combinedCoordinates.push({ coordinates: convertLatLngToCoord(site?.customerSite?.latitude, site?.customerSite?.longitude), obj: site?.customerSite });
        } else {
          combinedCoordinates.push({ coordinates: convertLatLngToCoord(site?.latitude, site?.longitude), obj: site });
        }
      })
    }
    
    return combinedCoordinates;
  }


  const latestLocationDriversMarkersRef = React.useRef<Array<google.maps.Marker>>([]);
  const driversPathMarkersRef = React.useRef<Array<google.maps.Marker>>([]);
  const polylineRef = React.useRef<Array<google.maps.Polyline>>([]);
  const defaultLocationsMarkersRef = React.useRef<Array<google.maps.Marker>>([]);
  const jobTemplateRef = React.useRef(values?.jobTemplate);
  const valuesRef = React.useRef(values.stepGroups);


  const prevCoordinates = React.useRef<Array<any>>([]);
  const coordinates = React.useMemo(() => {
    return getCoordinates(values.stepGroups);
  }, [values.stepGroups]);


  // React.useEffect(() => {
  //   setShowTrafficLayer(!checkStatus(values?.currentStatusName, ['completed', 'cancelled', 'failed']))
  // }, [values?.currentStatusName]);

  // React.useEffect(() => {
  //   setCustomButtons([
  //     {
  //       element: 'button',
  //       text: showTrafficLayer ? 'Hide traffic' : 'Show traffic',
  //       className: 'btn btn-custom-outlined btn-sm m-8',
  //       style: {
  //         position: 'absolute',
  //         bottom: '25px',
  //         right: '10px',
  //       },
  //       visible: true,
  //       disabled: false,
  //       callback: (e: any) => setShowTrafficLayer(!showTrafficLayer),
  //     }
  //   ]);
  // }, [showTrafficLayer]);

  React.useEffect(() => {
    valuesRef.current = values.stepGroups;
  }, [values.stepGroups]);
  
  React.useEffect(() => {
    jobTemplateRef.current = values?.jobTemplate;
  }, [values?.jobTemplate]);

  React.useEffect(() => {
    if (map) {
      if(customElements && customElements.length > 0){
        const elementsContainer = document.createElement('div');
        elementsContainer.style.width = '100%';
        elementsContainer.innerHTML = '';
        customElements.forEach((item: any, i: number) => {
          createCustomElements(map, elementsContainer, item)
        });
        
        const existingContainer = map.controls[window.google.maps.ControlPosition.BOTTOM_CENTER].getAt(0);
        if(existingContainer){
          while (existingContainer.firstChild) {
            existingContainer.removeChild(existingContainer.lastChild);
          }
          existingContainer.appendChild(elementsContainer);
        } else {
          map.controls[window.google.maps.ControlPosition.BOTTOM_CENTER].push(elementsContainer);
        }
      }
    }
  }, [customElements]);
  
  React.useEffect(() => {
    clearAllMarkers(latestLocationDriversMarkersRef);
    clearAllMarkers(driversPathMarkersRef);
    clearAllPolyline(polylineRef);

    if(!isEdit()){
      if(latestLocationDrivers && latestLocationDrivers.length > 0){
        if(values.driverId){
          let driver = latestLocationDrivers.find((x: any) => x.driverId === values.driverId);
          if(driver){
            addMarker(latestLocationDriversMarkersRef, {
              map: map,
              ...driver,
              ...driverMarkerIcon(driver.driverName, '#43936C'),
            }, (marker: any, markerItem: any) => {
              onClickDriver(markerItem);
            })
          }

        } else {
          latestLocationDrivers.forEach((item: any) => {
            addMarker(latestLocationDriversMarkersRef, {
              map: map,
              ...item,
              ...driverMarkerIcon(item.driverName, '#43936C'),
            }, (marker: any, markerItem: any) => {
              onClickDriver(markerItem);
            })
          });
        }

        // Arrow markers
        latestLocationDrivers.forEach((item: any, i: number) => {
          addMarker(driversPathMarkersRef, {
            map: map,
            ...item,
            ...arrowMarkerIcon(latestLocationDrivers, item, i),
          })
        });
        
        addPolyline(polylineRef, latestLocationDrivers.map((x: any) => x.position), {
          map: map,
          strokeColor: "#185CFF",
          strokeOpacity: 0.5,
          strokeWeight: 4,
        });
      }
    }
  }, [latestLocationDrivers, values.driverId, window.google])

  React.useEffect(() => {
    const isDifferentCoordinates = !areCoordinatesEqual(prevCoordinates.current, coordinates);
    if (isDifferentCoordinates) {
      prevCoordinates.current = coordinates;
      

      clearAllMarkers(defaultLocationsMarkersRef);
      let arr = getStepsFromStepGroups(values.stepGroups);
      if(arr && arr.length > 0){
        arr.forEach((stepObj: any, stepIndex: number) => {
          if(stepObj.locationType == LocationEnum.CustomerSite){
            if(validateLatLng(stepObj?.customerSite?.latitude, stepObj?.customerSite?.longitude)){
              addMarker(defaultLocationsMarkersRef, {
                map: map,
                position: {
                  lat: stepObj?.customerSite?.latitude,
                  lng: stepObj?.customerSite?.longitude,
                },
                title: stepObj.customerSite.address,
                spiderfy: true,
                ...defaultMarkerIcon((stepObj.stepCount+1).toString()),
              })
            }
          } else {
            if(validateLatLng(stepObj?.latitude, stepObj?.longitude)){
              addMarker(defaultLocationsMarkersRef, {
                map: map,
                position: {
                  lat: stepObj?.latitude,
                  lng: stepObj?.longitude,
                },
                spiderfy: true,
                title: stepObj.address,
                ...defaultMarkerIcon((stepObj.stepCount+1).toString()),
              })
            }
          }
        })
      }

      showRoute(map, coordinates,
        () => {
          let items = _.cloneDeep(customElements);
          items[0].text = 'Total: 0 km';
          setCustomElements(items);
          
          dispatch(slice.setTotalDistance(0));
          dispatch(slice.setTotalDuration(0));
          setFieldValue('totalDistance', 0);
        },
        () => {
          let items = _.cloneDeep(customElements);
          items[0].text = 'Total: 0 km';
          setCustomElements(items);
        },
        (directions: any) => {
          dispatch(slice.setDirections(directions));
        },
        (totalDistance: any) => {
          let items = _.cloneDeep(customElements);
          items[0].text = 'Total: ' + totalDistance + ' km';
          items[1].disabled = !(values.steps && values.steps.length > 0);
          setCustomElements(items);

          dispatch(slice.setTotalDistance(totalDistance));
          setFieldValue('totalDistance', totalDistance);
        },
        (totalDuration: any) => {
          dispatch(slice.setTotalDuration(totalDuration));
        }
      );
    }
  }, [coordinates]);


  
  const areCoordinatesEqual = (arr1: any, arr2: any) => {
    if (!Array.isArray(arr1) || !Array.isArray(arr2) || arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i]?.coordinates !== arr2[i]?.coordinates) return false;
    }
    return true;
  }

  const createCustomElements = (map = null, elementsContainer: any = null, { element = 'span', text = '', className = '', style = null, visible = true, disabled = false, callback = null }: any) => {
    try {
      if(map && elementsContainer){
          let el = document.createElement(element);
          el.className = className;
          el.textContent = text;
          el.disabled = disabled;
          if(style){
            Object.assign(el.style, style);
          }
          el.style.display = visible ? 'inline-block' : 'none';

          if(callback){
            el.addEventListener("click", callback);
        }
        elementsContainer.appendChild(el);
      }
    }catch(e){}
  }

  const onClickView = () => {
    if (valuesRef && valuesRef.current) {
      dispatch(
        jobSummarySlice.setShow({
          show: true,
          values: valuesRef.current,
          coordinates: getCoordinates(valuesRef.current),
        })
      );
    }
  }

  const onClickDriver = (markerItem: any) => {
    const currentJobTemplate = jobTemplateRef.current;
    if(currentJobTemplate){
      let item = (markerItem && markerItem.item) ? markerItem.item : null;

      let driver = (item && item.driver) ? item.driver : null;
      let driverId = (driver && driver.driverId) ? driver.driverId : null;
      let driverName = (driver && driver.driverName) ? driver.driverName : '';

      setFieldValue('driverId', driverId);
      setFieldValue('driverName', driverName);
      
      info(driverName, 'Driver has been assigned'); 

      if(values.vehicleId === null || values.vehicleId <= 0){
        if(driver && driver.defaultVehicle){
          let vehicleItem = driver.defaultVehicle;
          let vehicleId = (vehicleItem.vehicleId && vehicleItem.vehicleId > 0) ? vehicleItem.vehicleId : null;
          let vehicleName = (vehicleItem.vehicleName && vehicleItem.vehicleName !== '') ? vehicleItem.vehicleName : '';

          setFieldValue('vehicleId', vehicleId);
          setFieldValue('vehicleName', vehicleName);
        }
      }
      
      let selectedStatus = findStatus(currentJobTemplate?.templateStatuses, 'unassigned');
      if (values.statusId === null || values.statusId === 0 || values.statusId === selectedStatus.jobStatusId) {
        let newStatus = findStatus(currentJobTemplate?.templateStatuses, 'assigned');
        let newStatusId = (newStatus.jobStatusId) ? newStatus.jobStatusId : null;
        let newStatusName = (newStatus.jobStatusName) ? newStatus.jobStatusName : '';

        setFieldValue('statusId', newStatusId);
        setFieldValue('statusName', newStatusName);
      }
    }
  }


  return <Spin spinning={isLoadingLatestLocationDrivers}>
    <div style={{ height: '250px' }}>
      <GoogleMap
        canConextMenu={false}
        // customButtons={customButtons}
        // showTrafficLayer={showTrafficLayer}
        showTrafficLayer={!checkStatus(values?.currentStatusName, ['completed', 'cancelled', 'failed'])}
        options={{
          center: defaultLatLngZoom.coord,
          zoom: defaultLatLngZoom.zoom,
          mapTypeControl: false,
          streetViewControl: false,
          zoomControl: false,
          cameraControl: false,
          fullscreenControl: false,
          gestureHandling: "cooperative",
        }}
        onLoad={(map: any, ref: any) => {
          setMap(map);
        }}
      />
    </div>
  </Spin>
}

export default Map;
